import { Router, Route, Switch } from "react-router-dom";
import "./Components/Front/front.scss";
import Main from "./Components/Dashboard/Main";
import PrivateRoute from "./Components/PrivateRoute";
import { store, history } from "./_helpers";
import { Provider } from "react-redux";
import Front from "./Components/Front/Front";

function App({ location }) {
  return (
    <Provider store={store}>
      <Router history={history}>
        <Switch>
          <PrivateRoute path="/dashboard" component={Main} />
          <Route path="/" component={Front} />
        </Switch>
      </Router>
    </Provider>
  );
}

export default App;
